module.exports = __webpack_public_path__ + "static/img_step@2x-7f87c6f0cd113dc0ba9678272559d217.png";